/**
 * Is this product actually on promotion?
 *
 * The backend marks a promotion by setting `old_price` (the dashboard's
 * "activate promotion" tick writes exactly that column), so every price block
 * used to test `product.old_price` for truthiness. That broke for products
 * published from the POS: the bridge sent `oldPrice = sellPrice`, which stored
 * `old_price === price` and rendered a "discount" whose struck-through price
 * was identical to the real one.
 *
 * The bridge no longer does that, but rows written before the fix are still in
 * the database, so require a genuinely higher old price here too — that way
 * they display correctly without a data migration.
 */
export function hasDiscount(product) {
  if (!product) return false;
  const oldPrice = Number(product.old_price);
  const price = Number(product.price);
  if (!Number.isFinite(oldPrice) || !Number.isFinite(price)) return false;
  return oldPrice > price;
}

export default hasDiscount;
